export class IdNome {
  id?: number;
  nome?: string;
}
